import styled from 'styled-components';

export const FlexCell = styled.div`
	display: flex;
	justify-content: center;
	gap: 10px;
	align-items: center;
`;
